import axios from "axios";

const baseURL = (process.env.VITE_BASE_URL || process.env.NEXT_PUBLIC_API_V2_BASE_URL || '').includes('https://s-')
  ? 'https://s-auth.clickster.io/api'
  : 'https://auth.clickster.io/api';

// Auth.ts: ⚠️ No interceptors (used only for login endpoint)
export const AuthInstance = axios.create({
  baseURL,
});
